import React from 'react';

const RECOMMENDATION_COPY = {
  hire: { label: 'Recommended', color: 'text-[#1b5e20]' },
  consider: { label: 'Under Consideration', color: 'text-[#b8860b]' },
  pass: { label: 'Not a Fit', color: 'text-gray-600' },
};

export default function InterviewComplete({ result }) {
  if (!result) return null;

  const rec = RECOMMENDATION_COPY[result.recommendation] || {
    label: result.recommendation,
    color: 'text-gray-700',
  };

  return (
    <div className="max-w-2xl mx-auto p-8 bg-[#fdfaf0] rounded-xl border border-[#1b5e20]/20 shadow-sm">
      <h1 className="text-3xl font-bold text-[#1b5e20] mb-2">Interview Complete</h1>
      <p className="text-gray-600 mb-6">Thank you for completing the interview.</p>

      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 mb-6">
        <div>
          <div className="text-xs text-gray-500 uppercase tracking-wide">Overall Score</div>
          <div className="text-5xl font-bold text-[#1b5e20]">{result.overall_score}</div>
        </div>
        <div className="text-right">
          <div className="text-xs text-gray-500 uppercase tracking-wide">Status</div>
          <div className={`text-xl font-bold capitalize ${rec.color}`}>{rec.label}</div>
        </div>
      </div>

      {result.summary && (
        <div className="mb-6">
          <h3 className="font-semibold text-[#1b5e20] mb-2">Summary</h3>
          <p className="text-gray-700 leading-relaxed">{result.summary}</p>
        </div>
      )}

      {result.strengths?.length > 0 && (
        <div className="mb-6">
          <h3 className="font-semibold text-[#1b5e20] mb-2">Strengths</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            {result.strengths.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ul>
        </div>
      )}

      {result.concerns?.length > 0 && (
        <div className="mb-6">
          <h3 className="font-semibold text-[#b8860b] mb-2">Areas to Improve</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            {result.concerns.map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ul>
        </div>
      )}

      {result.dimension_scores && (
        <div>
          <h3 className="font-semibold text-[#1b5e20] mb-3">Dimension Scores</h3>
          <div className="space-y-2">
            {Object.entries(result.dimension_scores).map(([dim, score]) => (
              <div key={dim} className="flex items-center">
                <div className="w-36 text-sm text-gray-600 capitalize">
                  {dim.replace('_', ' ')}
                </div>
                <div className="flex-1 h-3 bg-gray-200 rounded-full overflow-hidden mr-3">
                  <div
                    className="h-full bg-[#1b5e20] transition-all"
                    style={{ width: `${score}%` }}
                  />
                </div>
                <div className="w-10 text-right text-sm font-semibold">{score}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
